<style scoped lang="scss" src="./AlertScreen.scss"></style>
<template>
  <main class="alert-screen">
    <div class="title">Não foi possível</div>
    <div class="subtitle">acessar {{ labelCameraOrMicrophone }}</div>
    <div class="text">
      Não conseguiremos seguir com o seu atendimento sem {{ labelCameraOrMicrophone }}. 
      Caso esteja tendo algum problema, 
      entre em contato com o nosso suporte.
    </div>
    <div class="image">
      <img alt="Sem Câmera" v-if="permissionCamera === false"  src="@/assets/NoCamera.png"/>
      <img alt="Sem microfone" v-if="permissionMicrophone === false" src="@/assets/NoMicrophone.png"/>
    </div>
    <div class="btn" @click="gotoHome">Voltar</div>
  </main>
</template>
<script>

export default {
  name: "AlertScreen",
  props: {
    permissionMicrophone: {
      type: Boolean,
      default: false,
    },
    permissionCamera: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
    };
  },

  computed: {
    labelCameraOrMicrophone () {
      return this.permissionCamera === false ? 'sua câmera' : 'seu microfone'
    },
  },

  watch: {
  },

  async mounted() {
  },

  methods: {
    gotoHome () {
      this.$router.push({path: "/"});
    }
  },
}
</script>
